import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

const DeleteConfirmationDialog = ({ searchName, closeDialog, confirmDelete, isLoading }) => {
  return (
    <Dialog fullWidth maxWidth="sm" open={true} onClose={closeDialog}>
      <div style={{ textAlign: 'center', padding: '24px' }}>
        <div style={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center', color: '#f44336' }}>
          <DeleteOutlineIcon fontSize="large" />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
          <Typography style={{ marginTop: '0', fontSize: '1.5rem' }}>Are you sure?</Typography>
          <Typography>
            You want to delete <span style={{ fontWeight: 'bold' }}>{`' ${searchName} '`}</span> ?
          </Typography>
          <Typography color="textSecondary">This action can't be undone </Typography>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', padding: '0 16px' }}>
            <Button fullWidth onClick={closeDialog} style={{ backgroundColor: '#e0e7ff', color: '#6366f1' }}>
              Cancel
            </Button>
            <Button fullWidth onClick={confirmDelete} variant="contained" color="primary" disabled={isLoading}>
              {isLoading ? <CircularProgress size={20} style={{ color: '#fff' }} /> : 'Delete'}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
